import { makeStyles } from 'tss-react/mui';
import { pickIf } from '../../../../utils/pickIf';

export const useStyles = makeStyles()(
  (theme, { fileName, isKiteUser } = {}) => ({
    message: {
      fontSize: 28,
      fontWeight: 700,
      marginBottom: theme.spacing(0.5),
      marginTop: theme.spacing(1.5),
      [theme.breakpoints.down('md')]: {
        fontSize: 16,
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          fontSize: 16,
        }),
      },
    },
    text: {
      color: theme.palette.grey2,
      fontSize: 18,
      margin: 0,
    },
    content: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      paddingTop: 50,
      paddingBottom: pickIf(fileName, 0, 40),
      [theme.breakpoints.down('lg')]: {
        paddingTop: pickIf(fileName, 12, 20),
        paddingBottom: pickIf(fileName, 32, 80),
      },
      [theme.breakpoints.down('md')]: {
        height: 'calc(79vh - 110px)',
        paddingTop: pickIf(fileName, 50, 80),
        justifyContent: 'initial',
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...(theme.isMobileDevice && {
          paddingTop: pickIf(fileName, 12, 20),
          paddingBottom: pickIf(fileName, 32, 80),
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          height: '70vh',
          paddingTop: 0,
          paddingBottom: theme.spacing(2),
          justifyContent: 'center',
        }),
      },
    },
    button: {
      backgroundColor: theme.palette.lightGrey,
      color: pickIf(isKiteUser, theme.palette.primary1, theme.palette.primary2),
      marginBottom: theme.spacing(3),
      marginTop: theme.spacing(1),
      height: 44,
      width: 110,
      padding: '8px 24px',
      '&:hover': {
        backgroundColor: `${theme.palette.lightGrey} !important`,
      },
    },
    fileName: {
      marginBottom: theme.spacing(2.5),
      marginTop: theme.spacing(1),
      [theme.breakpoints.down('md')]: {
        marginBottom: theme.spacing(3.5),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          marginTop: theme.spacing(0.5),
          marginBottom: theme.spacing(0.5),
        }),
      },
    },
    inputButton: {
      color: 'transparent',
      width: 110,
      height: 44,
      '&::before': {
        height: 44,
        background: theme.palette.lightGrey,
        borderRadius: 20,
        color: pickIf(
          isKiteUser,
          theme.palette.primary1,
          theme.palette.primary2,
        ),
        content: '"Replace"',
        display: 'inline-block',
        fontSize: 16,
        fontWeight: 700,
        padding: '12px 24px',
        outline: 'none',
        whiteSpace: 'nowrap',
        WebkitUserSelect: 'none',
        cursor: 'pointer',
      },
      '&::-webkit-file-upload-button': {
        display: 'none',
      },
    },
    book: {
      pointerEvents: pickIf(fileName, 'none', 'initial'),
    },
  }),
);
